"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.galleryActiveIds = exports.galleryHoverIds = exports.galleryFocusIds = void 0;
exports.galleryFocusIds = [
    'Primary-Focused-Empty',
    'Primary-Focused-Icon-Left',
    'Primary-Focused-Icon-Right',
    'Primary-Focused-Icon-Left-And-Right',
    'Primary-Focused-Icon-Only',
    'Secondary-Focused-Empty',
    'Secondary-Focused-Icon-Left',
    'Secondary-Focused-Icon-Right',
    'Secondary-Focused-Icon-Left-And-Right',
    'Secondary-Focused-Icon-Only',
    'Tertiary-Focused-Empty',
    'Tertiary-Focused-Icon-Left',
    'Tertiary-Focused-Icon-Right',
    'Tertiary-Focused-Icon-Left-And-Right',
    'Tertiary-Focused-Icon-Only',
    'Danger-Focused-Empty',
    'Danger-Focused-Icon-Left',
    'Danger-Focused-Icon-Right',
    'Danger-Focused-Icon-Left-And-Right',
    'Danger-Focused-Icon-Only',
    'DangerBorderless-Focused-Empty',
    'DangerBorderless-Focused-Icon-Left',
    'DangerBorderless-Focused-Icon-Right',
    'DangerBorderless-Focused-Icon-Left-And-Right',
    'DangerBorderless-Focused-Icon-Only',
    'Cancel-Focused-Empty',
    'Cancel-Focused-Icon-Left',
    'Cancel-Focused-Icon-Right',
    'Cancel-Focused-Icon-Left-And-Right',
    'Cancel-Focused-Icon-Only',
];
exports.galleryHoverIds = [
    'Primary-Hover-Empty',
    'Primary-Hover-Icon-Left',
    'Primary-Hover-Icon-Right',
    'Primary-Hover-Icon-Left-And-Right',
    'Primary-Hover-Icon-Only',
    'Secondary-Hover-Empty',
    'Secondary-Hover-Icon-Left',
    'Secondary-Hover-Icon-Right',
    'Secondary-Hover-Icon-Left-And-Right',
    'Secondary-Hover-Icon-Only',
    'Tertiary-Hover-Empty',
    'Tertiary-Hover-Icon-Left',
    'Tertiary-Hover-Icon-Right',
    'Tertiary-Hover-Icon-Left-And-Right',
    'Tertiary-Hover-Icon-Only',
    'Danger-Hover-Empty',
    'Danger-Hover-Icon-Left',
    'Danger-Hover-Icon-Right',
    'Danger-Hover-Icon-Left-And-Right',
    'Danger-Hover-Icon-Only',
    'DangerBorderless-Hover-Empty',
    'DangerBorderless-Hover-Icon-Left',
    'DangerBorderless-Hover-Icon-Right',
    'DangerBorderless-Hover-Icon-Left-And-Right',
    'DangerBorderless-Hover-Icon-Only',
    'Cancel-Hover-Empty',
    'Cancel-Hover-Icon-Left',
    'Cancel-Hover-Icon-Right',
    'Cancel-Hover-Icon-Left-And-Right',
    'Cancel-Hover-Icon-Only',
];
exports.galleryActiveIds = [
    'Primary-Active-Empty',
    'Primary-Active-Icon-Left',
    'Primary-Active-Icon-Right',
    'Primary-Active-Icon-Left-And-Right',
    'Primary-Active-Icon-Only',
    'Secondary-Active-Empty',
    'Secondary-Active-Icon-Left',
    'Secondary-Active-Icon-Right',
    'Secondary-Active-Icon-Left-And-Right',
    'Secondary-Active-Icon-Only',
    'Tertiary-Active-Empty',
    'Tertiary-Active-Icon-Left',
    'Tertiary-Active-Icon-Right',
    'Tertiary-Active-Icon-Left-And-Right',
    'Tertiary-Active-Icon-Only',
    'Danger-Active-Empty',
    'Danger-Active-Icon-Left',
    'Danger-Active-Icon-Right',
    'Danger-Active-Icon-Left-And-Right',
    'Danger-Active-Icon-Only',
    'DangerBorderless-Active-Empty',
    'DangerBorderless-Active-Icon-Left',
    'DangerBorderless-Active-Icon-Right',
    'DangerBorderless-Active-Icon-Left-And-Right',
    'DangerBorderless-Active-Icon-Only',
    'Cancel-Active-Empty',
    'Cancel-Active-Icon-Left',
    'Cancel-Active-Icon-Right',
    'Cancel-Active-Icon-Left-And-Right',
    'Cancel-Active-Icon-Only',
];
